// extracted by mini-css-extract-plugin
export default {"zoomModal":"f1-z","image":"g1-z","button":"h1-z","isOverlayShown":"i1-z"};